<template>
  <div v-loading.fullscreen.lock="isLoading">
    <el-card>
      <div slot="header">
        <!-- <el-button style="padding: 3px 0" type="text" @click="back">
          <i class="el-icon-arrow-left"></i>
        </el-button> -->
        <el-row style="line-height: 40px">
          <el-col :span="4">
            <span style="font-size: 16px; font-weight: bold"> 生活班管理 </span>
          </el-col>

          <el-col :span="6" :offset="14">

            <el-button 
              id="test_lifeClass_btAdd"
              style="float: right; margin-right: 10px"
              type="primary"
              @click="openDialog"
              >新增班級</el-button
            >

            <el-button
              style="float: right; margin-right: 10px"
              class="darkblue"
              @click="gotoImport"
            >
              匯入人員
            </el-button>
          </el-col>
        </el-row>
      </div>

      <el-col :span="4">
        <el-input
          :prefix-icon="qString == '' ? 'el-icon-search' : ''"
          placeholder="請輸入 生活班別"
          v-model="qString"
          @keyup.enter.native="query" 
        ></el-input>
      </el-col>

      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column
          prop="lifeName"
          label="生活班別"
          width="180"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="count"
          label="人數"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <!-- <el-table-column
          prop="studyName"
          label="主修學制班"
          header-align="center"
          align="center"
        >
        </el-table-column> -->

        <el-table-column
          fixed="right"
          label="操作"
          width="250"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="gotolifePerson(scope.row)">班員管理</el-button>
            <el-button
              type="primary"
              size="small"
              @click="openDialog(scope.row)"
              >編輯</el-button
            >
            <el-button type="danger" size="small" @click="deleteOne(scope.row)"
              >刪除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="生活班" :visible.sync="dialogShow" width="40%">
      <lifeClassAdd
        :clickTime="dialogTime"
        :id="dialogId"
        @close="closeDialog($event)"
      ></lifeClassAdd>
    </el-dialog>
  </div>
</template>

<script>
import API from "../../api/";
import Utils from "../../utils";
import { InformType } from "@/utils/InformType";
import lifeClassAdd from "./component/lifeClassAdd";

export default {
  name: "lifeClass",

  components: { lifeClassAdd },

  data() {
    return {
      isLoading: false,
      tableData: [],
      dialogShow: false,
      dialogTime: null,
      dialogId: NaN,
      addForm: {
        lifeName: "",
      },
      qString: "",
    };
  },

  created() {
    this.query();
  },

  methods: {
    query() {
      console.log("讀取");
      this.isLoading = true;
      API.lifeClass.query(this.qString).then((res) => {
        this.tableData = res.data;
        this.isLoading = false;
      });
    },
    openDialog(row) {
      this.dialogTime = new Date();
      this.dialogShow = true;
      this.dialogId = row ? row.id : NaN;
    },
    closeDialog($event) {
      console.log("go",$event);
      this.dialogShow = false;
      this.addForm.lifeName = "";
      if ($event) this.$router.push({ name: "人員匯入" });
      else this.query();
    },
    deleteOne(row) {
      this.isLoading = true;
      if (row.id) {
        API.lifeClass.deleteOne(row.id).then(() => {
          Utils.Message.send("刪除生活班成功!", InformType.SUCCESS);
          this.isLoading = false;
          this.query();
        }).catch(()=>{
          this.isLoading = false;
        });
      }
    },
    gotoImport() {
      this.$router.push({ name: "人員匯入" });
    },
    gotolifePerson(row) {
      this.$router.push({ path: `/lifePerson?id=${row.id}` });
    },
  },
};
</script>

<style>
.darkblue {
  background-color: #527bae;
  color: #ffffff;
}
</style>